export default "__VITE_ASSET__7f273342__"